<div class="p-col p-field">
    <label for="name">Nombre del nuevo informe</label>
    <input name="name" type="text" pInputText [(ngModel)]="report.name" />
</div>
<button pButton class="p-ml-3" style="float: right;" (click)="cloneReport()"><i class="fa fa-copy"></i> &nbsp;Duplicar informe</button>
<button pButton class="p-button-secondary" style="float: right;" (click)="cancel()">Cancelar</button>
